import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "react-bootstrap";
// import ActivitiesTable from "../../components/backend/activities/ActivitiesTable";
import ActivityService from "../../service/activity/ActivityService";
import IndexTable from "../../components/common/IndexTable";

function Activities({ loading, setLoading }) {
	const pageTitle = "Activities | RTO Mobile";

	return (
		<>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="robots" content="noindex,nofollow"></meta>
				<meta property="og:title" content={pageTitle} />
				<meta name="twitter:title" content={pageTitle} />
			</Helmet>
			<div className="rto_form-sections">
				<div className="rto_content-div" style={{ maxWidth: "1600px" }}>
					<Breadcrumb
						listProps={{ className: "w-100 justify-content-end" }}
					>
						<Breadcrumb.Item
							linkAs={Link}
							linkProps={{ to: "/dashboard" }}
						>
							Dashboard
						</Breadcrumb.Item>
						<Breadcrumb.Item
							linkAs={Link}
							linkProps={{ to: "/admin" }}
						>
							Admin
						</Breadcrumb.Item>
						<Breadcrumb.Item active>Activities</Breadcrumb.Item>
					</Breadcrumb>
					<div className="rto_title-div">
						<h1 className="rto_page-title">Activities</h1>
					</div>
					<div
						className="card card-outline card-primary"
						style={{
							borderTop: "3px solid #00aaff",
							boxShadow:
								"0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
						}}
					>
						<div className="card-body">
							{/* <ActivitiesTable
								loading={loading}
								setLoading={setLoading}
							/> */}
							<IndexTable
								model={"activities"}
								loading={loading}
								setLoading={setLoading}
								service={ActivityService}
								title="Activities"
								actionButtons={{
									updateLink: {
										path: "/activities",
									},
									// updateModal: {
									// 	enabled: true,
									// 	path: "/activities/update",
									// },
									// create: {
									// 	enabled: true,
									// 	path: "/activities/create",
									// },
								}}
								labels={[
									{
										id: "id",
										label: "ID",
										excluded: true,
									},
									{
										id: "actities_type_name",
										label: "Type",
									},
									{
										id: "assigned_to_username",
										label: "Assigned To",
									},
									{
										id: "description",
										label: "Description",
									},
									{
										id: "created_at",
										label: "Created At",
										displayTime: true,
									},
									{
										id: "model_id",
										excluded: true,
									},
									{
										// duplicate hidden column to adjust the link
										id: "model_id",
										excluded: true,
									},
									{
										// duplicate hidden column to adjust the link
										id: "model_id",
										excluded: true,
									},
									{
										id: "model",
										excluded: true,
									},
									{
										// duplicate hidden column to adjust the link
										id: "model_name",
										label: "Name",
										excluded: true,
									},
									{
										id: "model_name",
										label: "Name",
										model_link_alt: true,
									},
								]}
								apiBase="/activity"
								successRedirectBase="activities"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Activities;
